import { useParams } from 'react-router-dom';

import { useGetRequest } from 'hooks';
import { getIsNew } from 'utils';

import { Retailer } from 'codegen';

import { initRetailerSuccessAction } from '../store';

export const useRetailerDetails = () => {
  const { retailerId } = useParams();
  const isNew = getIsNew(retailerId);

  const { loading } = useGetRequest<Retailer>({
    url: `/merchants/${retailerId}`,
    options: {
      ready: !isNew,
      refreshDeps: [retailerId],
      onSuccess: ({ data }) => initRetailerSuccessAction(data),
    },
  });

  return { loading };
};
